<script setup>
import { ref, computed, watch, } from 'vue';
import { PaginationRoot, PaginationList, PaginationListItem, PaginationFirst, PaginationPrev, PaginationLast, PaginationNext, } from 'reka-ui';
import { ChevronsLeft, ChevronsRight, } from 'lucide-vue-next';
import PaginationEllipsis from '~/components/ui/pagination/PaginationEllipsis.vue';

const props = defineProps({
  totalItems: {
    type: Number,
    required: true,
  },
  itemsPerPage: {
    type: Number,
    default: 5,
  },
  buttonClass: { type: null, required: false },
  iconClass: { type: null, required: false },
  showFirstLast: {
    type: Boolean,
    default: false,
  },
  showNumberList: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['pageChanged']);

const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage));

watch(currentPage, (newPage) => {
  console.log('pagination page change', newPage);
  emit('pageChanged', newPage);
});
</script>

<template>
  <div class="flex flex-col items-center md:flex-row pt-3">
    <PaginationRoot
      v-model:page="currentPage"
      :total="totalPages"
      sibling-count="1"
      show-edges
    >
      <PaginationList
        v-slot="{ items }"
        class="flex flex-wrap justify-center items-center gap-1"
      >
        <PaginationFirst
          v-if="showFirstLast">
          <t-button
            class="border-2 border-primary-140 text-primary-140"
            :class="buttonClass"
          >
            <slot>
              <ChevronsLeft />
            </slot>
          </t-button>
        </PaginationFirst>
        <PaginationPrev>
          <t-button
            class="border-2 border-primary-140 text-primary-140"
            :class="buttonClass"
          >
            <slot>
              <t-icon
                :class="iconClass"
                name="chevron-left"/>
            </slot>
          </t-button>
        </PaginationPrev>
        <template v-if="showNumberList">
          <template
            v-for="(item, idx) in items"
            :key="idx"
          >
            <PaginationListItem
              v-if="item.type === 'page'"
              :value="item.value"
              as-child
            >
              <t-button
                :class="item.value === currentPage ? 'border-2 border-primary-140 bg-primary-140 text-white hover:text-primary-140' : 'border-2 border-primary-140 text-primary-140'"
              >
                {{ item.value }}
              </t-button>
            </PaginationListItem>
            <PaginationEllipsis v-else>
              <p>...</p>
            </PaginationEllipsis>
          </template>
        </template>

        <PaginationNext>
          <t-button
            class="border-2 border-primary-140 text-primary-140"
            :class="buttonClass"
          >
            <slot>
              <t-icon
                :class="iconClass"
                name="chevron-right"/>
            </slot>
          </t-button>
        </PaginationNext>
        <PaginationLast     v-if="showFirstLast">
          <t-button
            class="border-2 border-primary-140 text-primary-140"
            :class="buttonClass"
          >
            <slot>
              <ChevronsRight />
            </slot>
          </t-button>
        </PaginationLast>
      </PaginationList>
    </PaginationRoot>
  </div>
</template>
